module.exports = __webpack_public_path__ + "static/media/wargames.89223811.gif";